import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { DeleteDialogWindowComponent } from './delete-dialog-window/delete-dialog-window.component';
import { DialogWindowComponent } from './dialog-window/dialog-window.component';
import { WarnDialogWindowComponent } from './warn-dialog-window/warn-dialog-window.component';
import { CustomDialogWindowComponent } from './custom-dialog-window/custom-dialog-window.component';

@NgModule({
  declarations: [DialogWindowComponent, DeleteDialogWindowComponent, WarnDialogWindowComponent, CustomDialogWindowComponent],
  imports: [
    SharedModule
  ],
  exports:[
    DialogWindowComponent
  ]
})
export class DialogsModule { }
